import React from 'react';
import PropTypes from 'prop-types';
import { Message } from '@aperza/ui';

const CustomPageDetailContentFormSuccess = (props) => {

  let {
    messageId
  } = props;

  return (
    <div style={{padding: '20px', width: '100%', textAlign: 'center'}}>
      <Message messageId={messageId} />
    </div>
  );
};

CustomPageDetailContentFormSuccess.propTypes = {
  messageId: PropTypes.string,
};

export default CustomPageDetailContentFormSuccess;
